import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_ORDER_CODE_SPLIT } from '../queries/GetOrderDetails';

const fetchCodeSplit = async ({ queryKey }) => {
    const [, { token, item, handleShowMessage, formatNumber }] = queryKey;

    if (!token || !formatNumber) throw new Error('token not available or format number not found');
        
    try {
        const response = await axios.get(
            `/getCodeStringSplit?&formatNumber=${encodeURIComponent(formatNumber)}&codeString=${encodeURIComponent(item.code)}&specialNotes=${encodeURIComponent(item.specialText)}&soNumber=${encodeURIComponent(item.so)}`,            
            {
            headers: {
                Authorization: token,
            },
            }
        );

        return response.data;

    } catch (error) {
        handleShowMessage(error.response.data ,"error");
    }
};

export const useGetOrderCodeSplit = (params) => {
    return useQuery({
        queryKey: [GET_ORDER_CODE_SPLIT, params],
        queryFn: fetchCodeSplit,
        enabled: !!params.token && !!params.formatNumber,
        retry: false,
    });
};
